import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// distributor
import DistDashboard from "../DistributorLogin/DistDashboard";
import OrderList from "../DistributorLogin/OrderList";
import DisReturnTable from "../DistributorLogin/DisReturnTable";
import MyInventory from "../DistributorLogin/MyInventory";
import AddNewInventory from "../DistributorLogin/AddNewInventory";
import BulkUploadInv from "../DistributorLogin/BulkUploadInv";
import ListNewProductInv from "../DistributorLogin/ListNewProductInv";
import UpdateInventory from "../DistributorLogin/UpdateInventory";
import ReturnOrderDetails from "../DistributorLogin/ReturnOrderDetails";
import OrderDetails from "../DistributorLogin/OrderDetails";
import Invoice from "../DistributorLogin/Invoice";
import Offers from "../DistributorLogin/offers/Offers";
import CreatePayment from "../DistributorLogin/payments/CreatePayment";
import CreateOrder from "../DistributorLogin/createorder/CreateOrder";

export default function Routerpage() {
  return (
    <>
      <Router>
        <Switch>
          {/* dislogin */}
          <Route exact path="/" component={DistDashboard} />
          {/* distributor */}
          <Route path="/orderlist" component={OrderList} />
          <Route path="/distreturn" component={DisReturnTable} />
          <Route path="/returorderdetails" component={ReturnOrderDetails} />
          <Route path="/myinventory" component={MyInventory} />
          <Route path="/addnewinv" component={AddNewInventory} />
          <Route path="/bulkuploadinv" component={BulkUploadInv} />
          <Route path="/listnewinv" component={ListNewProductInv} />
          <Route path="/updateinv" component={UpdateInventory} />
          <Route path="/orderdetails" component={OrderDetails} />
          <Route path="/invoice" component={Invoice} />
          <Route path="/offers" component={Offers} />
          <Route path="/payments" component={CreatePayment} />
          <Route path="/createorder" component={CreateOrder} />
        </Switch>
      </Router>
    </>
  );
}
